import { Widget } from '@typeform/embed-react';
import type { NextPage } from 'next';

import { Meta } from '@/layouts/Meta';
import { Main } from '@/templates/Main';

const Corporate: NextPage = () => {
  return (
    <Main
      meta={
        <Meta
          title={'MYMC Corporate Partnership'}
          description={
            'My Muscle Chef Corporate Partnership & Employee Benefits Program'
          }
          noIndexing={true}
        />
      }
    >
      <div className="h-screen w-full">
        <Widget id="oHARba" style={{ width: '100%', height: '100%' }} />
      </div>
    </Main>
  );
};

export default Corporate;
